




















import {
	defineComponent, PropType,
} from '@vue/composition-api';
import { Size, Spacing } from '@front-app/components/constants';
import { EventManagementData } from '@front-app/services/EventsApi/EventModel';
import { syncedRef } from '@front-app/util/reactivity';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import RichTextSection from '@front-app/components/form/RichTextSection.vue';
import EditEventBaseForm from './EditEventBaseForm.vue';
import { useEventAdminStore } from '../../store/EventAdmin';

export default defineComponent({
	components: {
		RichTextSection,
		EditEventBaseForm,
	},
	props: {
		eventData: {
			type: Object as PropType<EventManagementData>,
			required: true,
		},
	},
	setup(props, ctx) {
		const purpose = syncedRef(() => props.eventData.purpose).ref;

		const {
			track,
			isLoading: isSavingUpdates,
			isError: isErrorSavingUpdates,
			isSuccess: isSuccessSavingUpdates,
		} = useAsyncStatus();

		const saveUpdates = async () => {
			await track(useEventAdminStore().update(props.eventData.id, { purpose: purpose.value }));

			if (isSuccessSavingUpdates.value) {
				ctx.emit('close');
			}
		};

		return {
			purpose,
			isSavingUpdates,
			isErrorSavingUpdates,
			saveUpdates,
			// Util
			Size,
			Spacing,
			ButtonPalettes,
		};
	},
});
